module.exports = new __parcel__URL__("goblin.16b663ca.webp").toString();